import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/42/thumb-landscape.jpg"

const Post42 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">CELINE／スモールバーティカルカバ／28 x32 x8cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>シンプルでタイムレスなデザインが多く大人女子に人気のブランドCELINE（セリーヌ）。今回は、2019年の登場より人気のパリ凱旋門のチェーンから着想のモノグラム「トリオンフ　キャンパス」(TRIOMPHE CANVAS)シリーズを一挙公開！今季のトレンドコーディネートに合わせて幅広くご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.トリオンフキャンバス(TRIOMPHE CANVAS)バーティカルカバ（スモール・ミニ）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.セーラーバッグ </ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.スモールドローストリングバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.マイクロドローストリング</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.クレシーバケット</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>6.ミディアムバケット</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>7.ミュージアムバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80}>8.ファルコ</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec9" smooth={true} duration={500} offset={-80}>9.スモールカメラバッグ</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec10" smooth={true} duration={500} offset={-80}>10.トライアングルバッグ</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec11" smooth={true} duration={500} offset={-80}>11.チェーンクラッチ</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec12" smooth={true} duration={500} offset={-80}>12.トリオンフミディアム</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec13" smooth={true} duration={500} offset={-80}>13.ミニボストンバッグ</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec14" smooth={true} duration={500} offset={-80}>14.ボストンバッグ</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec15" smooth={true} duration={500} offset={-80}>15.ラージクーファン</ScrollLink><br></br>          
          <ScrollLink className="scroll" to="sec16" smooth={true} duration={500} offset={-80}>16.まとめ</ScrollLink>                    
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/42/1.jpg" alt="手元から気分が上がる！CELINE（セリーヌ）人気バッグをご紹介"/>
      </figure>                 
      <div name="sec1" className="text-max-width">
        <h2>1.トリオンフキャンバス　スモールバーティカルカバ（右） /28x32x8cm(幅x高さxマチ)</h2>
        <p>
          付属のショルダーストラップを付けて、2wayで使用可能なバッグ。ジップ付きインナーポケットがついています。A4サイズも収納可能でオンにもオフにも使用できると人気です。
        </p><br></br>
        <h2>ミニバーティカルカバ（左） /16x20x5cm(幅x高さxマチ)</h2>
        <p>
          コンパクトでかわいい♡こちらは間仕切りのないタイプ。ちょっとしたお出かけにも、ショルダー付きでいつものカジュアルコーデも格上げになるバッグです。バーティカルカバはストラップ・ハンドルカラー展開、キャンパス生地にプリントのものなど現在たくさんのシリーズがあります！（ラクサスで取扱中のものを一部ご紹介しています。）
        </p>        
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/2.png" alt="手元から気分が上がる！CELINE（セリーヌ）人気バッグをご紹介"/>
      </figure>               
      <div name="sec2" className="text-max-width">
        <h2>2.ミディアムセーラーバッグ /24x40x17cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/3.jpg" alt=""/>
      </figure>        
      <p className="text-max-width">             
        ドローストリングデザインのバッグパックは収納力抜群です。ユニセックスで利用可能で、カジュアルアイテムにプラスするとアーバンスポーティーMIXコーデの完成！
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/4.png" alt=""/>
      </figure>        
      <div name="sec3" className="text-max-width">
        <h2>3.スモールドローストリングバッグ /15x21x15cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/5.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        程よいサイズ感。ドローストリングデザインではありながらきちんと感も見せてくれます。ストラップは調節可能です。
      </p>        
      <div name="sec4" className="text-max-width">
        <h2>4.マイクロドローストリングバッグ /9x17x9cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/6.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        とってもコンパクトなドローストリングバッグ。休日のお出かけバッグとしても◎
      </p>
      <div name="sec5" className="text-max-width">
        <h2>5.クレシーバケット /15x23x15cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/7.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        ホースビットをあしらったバケットタイプのバッグは、程よいヴィンテージ感を演出してくれます。ジーンズ合わせで、70’s風コーデもかわいい♡
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/8.png" alt=""/>
      </figure>
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
       CELINEのバッグを見る
      </Link>         
      <div name="sec6" className="text-max-width">
        <h2>6.ミディアムバケット /24x27x18cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/9.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        ストラップは長さ調節可能で、ショルダーでもボディバッグとしても使えます。さまざまなシーンに使いやすいバケット型。
      </p>
      <div name="sec7" className="text-max-width">
        <h2>7.ミュージアムバッグ /31x39x12cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/10.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        人気のトート型。バッグ自体も軽いので、書類も持ち運びしやすいのでお仕事にも活躍します。取り外し可能なジップポーチ付きです。
      </p>    
      <div name="sec8" className="text-max-width">
        <h2>8.ファルコ /18x13x6cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/11.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        さりげなくベルトにあしらった刻印ロゴがポイント！ショッピングや旅行などにもおすすめです。
      </p>
      <div name="sec9" className="text-max-width">
        <h2>9.スモールカメラバッグ /18x15x5cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/12.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        コロンとしたシルエットがキュートかつエレガントなカメラバッグ。ストラップの調節で、ショルダー・クロスボディと使い分けが出来ます。
      </p>
      <div name="sec10" className="text-max-width">
        <h2>10.トライアングルバッグ /20x15x4cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/13.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        シルエットと、セリーヌのロゴが目を引くバッグ。レザーストラップも調節可能です。コーデに差をつけたい方にもオススメ。フラップ部分にマグネットがついており、開閉もしやすいバッグです。
        </p>
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
       CELINEのバッグを見る
      </Link>     
      <div name="sec11" className="text-max-width">
        <h2>11.チェーンクラッチ /16x11x9cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/14.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        クラッチバッグに、付属のゴールドのチェーンでショルダーバッグとしても使えます。華奢なチェーンがより大人かわいい雰囲気を演出してくれます。
      </p>
      <div name="sec12" className="text-max-width">
        <h2>12.トリオンフミディアム /18x13x5cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/15.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        70年代にCELINE（セリーヌ）のエンブレムとして使用されていた「トリオンフ」が留め具に輝くシグネチャーバッグ。
      </p>
      <h2>トリオンフミディアム シャイニーカーフスキン/21x24x4cm(幅x高さxマチ)</h2>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/42/16.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/42/17.jpg" alt=""/>
        </figure>        
      </div>
      <p className="text-max-width">
        こちらは、同型カーフスキンシリーズもあります。
      </p>
      <div name="sec13" className="text-max-width">
        <h2>13.ミニボストンバッグ /14x10x6cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/18.jpg" alt=""/>
      </figure>
      <div className="text-max-width">
        <p>ショルダーストラップ付きのコンパクトなボストンバッグ。ゴールドのチェーンがポイントとなり、小さいながらも存在感のあるバッグです。</p>
      </div>
      <div name="sec14" className="text-max-width">
        <h2>14.ボストンバッグ /31x19x15cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/19.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        ダブルジップで間口が広く使いやすい！化粧ポーチやスマホ、お財布など大抵のものは入ります。カギ、カデナ、クロシェット付きです。
      </p>    
      <div name="sec15" className="text-max-width">
        <h2>15.ラージクーファン /24x31x20cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/20.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        2021SSの新作！春夏らしい白地にトリオンフモチーフの大きめのトートバッグですが、使えるのは春夏だけ？そんなことないんです！重めコーデになりがちな秋冬のコーデのポイントとしても。年中使いやすいバッグです♡
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/42/21.png" alt=""/>
      </figure>        
      <div name="sec16" className="text-two-cloumn">
        <h2>16.まとめ</h2>
        <p>
          いかがでしたでしょうか？<br></br>トリオンフシリーズ、シーズンごとに新たなバリエーションが発表され、たくさん種類がありどれもステキで迷ってしまいますよね。やはり、バッグ選びのポイントは実際に手に取ること！一度、実際にバッグを手に取ってみてはいかがでしょうか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
       CELINEのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post42

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 42}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
